//import Calendar from 'rc-year-calendar'
import React, { Component } from 'react'
import Button from '../../Button'
import Close from '../../Icons/Close'
import Messengers from '../../Messengers'
import Overlay from '../../Overlay'
import VisitCalendar from '../../VisitCalendar'
//import VisitDetals from '../../VisitDetals'
import ContactToManager from '../../Visits/ContactToManager'
import moment from "moment"

const statuses = {
  new: "Новая",
  agreement: "Согласование",
  agreed: "Назначенная",
  visited: "Состоявшаяся",
  late: "Просроченная",
  declined: "Отменена",
  waiting: "Ожидание",
  old: "Старая",
  personally: "На связи лично",
  noVisit: "Нет встречи",
}

export default class ProfileMeetingCard extends Component {

  constructor(props){
    super(props)

    this.state = {
      showVisitsCalendar: false,
      showGratitude: false
    }

  }

  render() {
    const { data, back, user } = this.props
    
    const onSave = () => {
      this.setState({showVisitsCalendar: false, showGratitude: true})
    }

    if(data.status !== "agreement"){
      return (
        <div className='ProfileContainer'>
          <div className='ProfileContainer__wrapper'>
              <div className='ProfileContainer__header'>
                  <img className='ProfileContainer__header-arrow' src="/assets/img/arrow.png" alt="" onClick={back}/>
                  <p className='ProfileContainer__header-left'>Встреча с меценатом</p>
                  <p className='ProfileContainer__header-right'>{data.status === "new" || data.status === "old" || data.status === "personally" || data.status === "waiting" ? "ожидает согласования" :  `завершилась ${moment(data.date).utc().add(3, 'hours').format('DD/MM/YYYY')}` }</p>
              </div>
              <div className='ProfileContainer__main ProfileContainer__main_grid ProfileContainer__main_rows'>
                <div className='ProfileContainer__output'>
                  <p className='ProfileContainer__output-top'>Статус встречи</p>
                  <div className='ProfileContainer__output-main'>
                    {statuses[data.status]}
                  </div>
                </div>
                <div className='ProfileContainer__output'>
                  <p className='ProfileContainer__output-top'>Меценат</p>
                  <div className='ProfileContainer__output-main'>
                    {`${data.user.name} ${data.user.surname}`}
                  </div>
                </div>
              </div>
          </div>
          <Messengers/>
      </div>
      )
    }

    return (
      <div className='ProfileContainer'>
          <div className='ProfileContainer__wrapper'>
              <div className='ProfileContainer__header'>
                  <img className='ProfileContainer__header-arrow' src="/assets/img/arrow.png" alt="" onClick={back}/>
                  <p className='ProfileContainer__header-left'>Встреча с меценатом</p>
                  <p className='ProfileContainer__header-right'>ожидает подтверждения</p>
              </div>
              <div className='ProfileContainer__main ProfileContainer__main_grid ProfileContainer__main_rows'>
                <div className='ProfileContainer__output'>
                  <p className='ProfileContainer__output-top'>Статус встречи</p>
                  <div className='ProfileContainer__output-main'>
                    Согласование
                  </div>
                </div>
                <div className='ProfileContainer__output'>
                  <p className='ProfileContainer__output-top'>Меценат</p>
                  <div className='ProfileContainer__output-main'>
                  {`${data.user.name} ${data.user.surname}`}
                  </div>
                </div>
                <div className='ProfileContainer__output ProfileContainer__output-small'>
                  Выберите, пожалуйста, 5 опций для встречи с мецентом
                </div>
                <div className="Become-member__agreement">
                  <label className='Become-member__agreement-container'>
                    {/* <input type='checkbox' name='offerCheckbox' onChange={alert}/>  */}
                    <input type='checkbox' name='offerCheckbox'/> 
                    <div className='Become-member__agreement-checkbox'>
                    <div className='Become-member__agreement-checkbox-arrow'></div>
                    </div>
                    <span className='Become-member__agreement-text' style={{color: "black"}}>Напомнить о встрече<a className='member-anketa-policyLink' target='_blank' rel='noopener noreferrer' href='/policy' style={{textDecoration: "underline"}}> </a></span>
                  </label>
                </div>
              </div>
            <Button theme="orange w100" onClick={() => this.setState({showVisitsCalendar: true})}>Назначить</Button>
          </div>
          <Messengers/>
          <Overlay isActive={this.state.showVisitsCalendar} onClose={() => this.setState({showVisitsCalendar: false})} klassModifier={"mfc-modal_3 ProfileContainer__visits-modal"}>
              <VisitCalendar visit={data} role={user.role} personId={user.person._id} onSave={onSave}/>
          </Overlay>
          {/* <Overlay isActive={this.state.showVisitsDetals} onClose={()=> this.setState({showVisitsDetals: false})} klassModifier={"mfc-modal_3"}>
              <VisitDetals visit={data} />
          </Overlay> */}
          <Overlay isActive={this.state.showGratitude} onClose={() => this.setState({showGratitude: false})} klassModifier={"welcome-persone mfc-modal_4"}>
            <div className='ProfileContainer__modal ProfileContainer__modal_red' style={{position: "relative"}}>
              <div className='ProfileContainer__modal-wrapper'>
                <div className='ProfileContainer__modal-header'>
                  <p className='ProfileContainer__modal-header-title'>
                    Спасибо за выбор!
                  </p>
                </div>
                <div className='ProfileContainer__modal-main'>
                  Мы передаем ваши опции меценату. После выбора мецената вам придет уведомление. И конечно, вы всегда можете связться с менеджером, если вам нужна поддержка 
                </div>
                <ContactToManager info={data} role={user.role} classList='Button Button_black Button_black-white'/>
              </div>
              <div className='ProfileContainer__modal-close' onClick={() => this.setState({showGratitude: false})}><Close/></div>
            </div>
          </Overlay>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/PersonProfile/ProfileContainers/ProfileMeetingCard.jsx